const UserIcon = ({ size = 24, className }) => {
  return (
    <img
      src={require("../../../assets/images/user_icon.svg").default}
      alt="user icon"
      width={size}
      className={className}
    />
  );
};
export default UserIcon;
